import { matchPath } from 'react-router-dom';

import { FASTSHIFT_PATHS, FASTSHIFT_PATH_KEYS } from '@/common/routes/constants';
import { parseRoute } from '@/fastshift-portal-routes';

const FASTSHIFT_PATH_ENTRIES = Object.entries(FASTSHIFT_PATHS) as Array<
	[FASTSHIFT_PATH_KEYS, string]
>;

/**
 * Resolves the current route key without React context, so non-component code can scope
 * behaviour by route. `useRoutes` cannot be used here because it needs router hooks, and its
 * `paths` map only contains the routes reachable from the current URL's params.
 *
 * Uses `matchPath` rather than string comparison because the `FASTSHIFT_PATHS` patterns carry
 * `:domainId`, `:organizationId` and `:instanceId` placeholders.
 *
 * Returns `undefined` for any path outside `FASTSHIFT_PATHS` — including the legacy
 * `FASTSHIFT_EAP_HOME_PATH`, which is deliberately not a declared route.
 */
export function getFastshiftRouteKey(): FASTSHIFT_PATH_KEYS | undefined {
	if (typeof window === 'undefined') {
		return undefined;
	}

	// `parseRoute` strips the locale prefix and leading slashes; `matchPath` anchors its compiled
	// pattern on a leading slash, so one has to go back on.
	const pathname = `/${parseRoute(window.location).path}`;

	return FASTSHIFT_PATH_ENTRIES.find(([, pattern]) => matchPath(pattern, pathname) !== null)?.[0];
}
